import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { EventAttendeeQuestion } from '@models/event-attendance/event-attendee-question.model';
import { EventAttendee } from '@models/event-attendance/event-attendee.model';
import { AccountRequirement } from '@models/events/account-requirement.enum';
import { EventSlot } from '@models/events/event-slot.model';
import { User } from '@models/users/user.model';
import { EventRsvpQuestionComponent } from '@modules/events/components/event-rsvp-question/event-rsvp-question.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@services/auth/auth.service';
import { FormsModules } from '@utils/shared-modules';

@Component({
  selector: 'app-booking-event-slot-assign-ticket-card',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModules,
    TranslateModule,
    MatCheckbox,
    EventRsvpQuestionComponent,
  ],
  templateUrl: './booking-event-slot-assign-ticket-card.component.html',
  styleUrl: './booking-event-slot-assign-ticket-card.component.scss',
})
export class BookingEventSlotAssignTicketCardComponent implements OnChanges {
  @Input() assignToBuyer: boolean = false;
  @Input() index?: number;
  @Input() eventTicketId?: number;
  @Input() dataFields?: EventAttendeeQuestion[];
  @Input() slot?: EventSlot;
  @Input() attendeeForm?: FormGroup;
  @Input() attendee?: EventAttendee;
  loggedUser?: User;
  @Input() form!: FormGroup;
  @Input() showAssignToBuyer = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['form']) {
      this._form = this.form;
    }
  }
  private _form!: FormGroup;

  constructor(private authService: AuthService) {
    this.authService.userSubject
      .pipe(takeUntilDestroyed())
      .subscribe((user) => (this.loggedUser = user));
  }

  getAsteriskIfRequired(controlName: string): string {
    const requiredControls = ['email'];
    if (this.slot?.accountRequirement === AccountRequirement.NO_ACCOUNT) {
      requiredControls.push(...['firstName', 'lastName']);
    }

    if (requiredControls.includes(controlName)) return '*';
    return '';
  }

  populateFields(isChecked: boolean) {
    if (isChecked) {
      if (
        this.loggedUser &&
        this.loggedUser.id !== 0 &&
        this.attendeeForm?.controls['firstName'].value.trim() === ''
      ) {
        this._form.controls['firstName'].patchValue(
          this.loggedUser.getFirstName(),
        );
        this._form.controls['lastName'].patchValue(
          this.loggedUser.getLastName(),
        );
        this._form.controls['email'].patchValue(this.loggedUser.email);
      } else {
        this._form.controls['firstName'].patchValue(
          this.attendeeForm?.controls['firstName'].value,
        );
        this._form.controls['lastName'].patchValue(
          this.attendeeForm?.controls['lastName'].value,
        );
        this._form.controls['email'].patchValue(
          this.attendeeForm?.controls['email'].value,
        );
      }
    } else {
      this._form.controls['firstName'].patchValue('');
      this._form.controls['lastName'].patchValue('');
      this._form.controls['email'].patchValue('');
    }
  }

  protected readonly AccountRequirement = AccountRequirement;
}
